import { render, staticRenderFns } from "./AddItem.vue?vue&type=template&id=060b5d22&"
import script from "./AddItem.vue?vue&type=script&lang=js&"
export * from "./AddItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('060b5d22')) {
      api.createRecord('060b5d22', component.options)
    } else {
      api.reload('060b5d22', component.options)
    }
    module.hot.accept("./AddItem.vue?vue&type=template&id=060b5d22&", function () {
      api.rerender('060b5d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddressBook/AddItem.vue"
export default component.exports